App.prototype.ageConfirmation = function () {
    $.ajax({
        type: 'GET',
        url: App.prototype.apiAddress + 'age-confirmation',
        dataType: "json",
        success: function () {

            $('#modal-age-confirmation').remove();

        },
    });
};
